exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.div-header[data-v-eea68638]{\n\t\tdisplay: -webkit-box;\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay: flex;\n\t\t-webkit-box-pack: end;\n\t\t    -ms-flex-pack: end;\n\t\t        justify-content: flex-end;\n}\n.div-header .btn-font[data-v-eea68638]{\n\t\tfont-size: 18px;\n\t\tline-height: 0 !important;\n}\n", ""]);

// exports
